import { Component, ViewChild, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { faLock, faClipboard } from '@fortawesome/free-solid-svg-icons';

import { ClipboardService } from 'services/clipboard/clipboard.service';
import { GoogleAuthData } from 'core';

@Component({
  selector: 'app-two-factor-enabled',
  templateUrl: './two.factor.enabled.component.html',
  styleUrls: ['./two.factor.enabled.component.scss'],
})
export class TwoFactorEnabledComponent {
  @ViewChild('twoFactorEnabled') dialogTempRef: TemplateRef<unknown>;

  readonly faLock = faLock;
  readonly faClipboard = faClipboard;

  googleAuthData: GoogleAuthData;
  modalRef: BsModalRef;
  replace = false;

  constructor(private clipboardServices: ClipboardService, private modalService: BsModalService) {}

  showConfirmation(googleAuthData: GoogleAuthData, replace = false): void {
    this.googleAuthData = googleAuthData;
    this.replace = replace;
    this.modalRef = this.modalService.show(this.dialogTempRef, { class: 'my-modal modal-lg' });
  }

  copySecretKey(): void {
    this.clipboardServices.copyToClipboard(this.googleAuthData.key, 'Secret key copied.');
  }
}
